import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";

@Component({
  selector: "app-secure-reopen-case",
  templateUrl: "./reopen-case.component.html",
})
export class ReopenCaseComponent implements OnInit {
  reopenForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController
  ) {}

  ngOnInit(): void {
    this.reopenForm = new FormGroup({
      reopenReason: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(2000),
      ]),
    });
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  reopen() {
    if (!this.reopenForm.value.reopenReason) {
      this.showErrorToast("Please Enter reopen Reason");
    }
    if (confirm("Are you sure to reopen this applicant  -" + this.pan + ".")) {
      if (this.reopenForm.valid) {
        return this.modalCtrl.dismiss(
          this.reopenForm.value.reopenReason,
          "reopen"
        );
      }
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
